import * as React from 'react';
import { Typography } from '@mui/material';
export var TitlePortal = function (_a) {
    var className = _a.className;
    return (React.createElement(Typography, { flex: "1", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", variant: "h6", color: "inherit", id: "react-admin-title", className: className }));
};
//# sourceMappingURL=TitlePortal.js.map